// COMPONENT: MarbleScoreExplorer activates the selectable guide-page scale; product accordions remain static.
class MarbleScoreExplorer extends HTMLElement {
  connectedCallback() {
    if (this.isInitialized) return;

    this.isInitialized = true;
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
    this.isInitialized = false;
  }

  setActive(activeButton) {
    const scoreIndex = activeButton.dataset.scoreIndex;
    const buttons = [...this.querySelectorAll('[data-marble-score-button]')];
    const panels = [...this.querySelectorAll('[data-marble-score-panel]')];
    const marker = this.querySelector('[data-marble-score-marker]');
    const section = this.closest('[data-section-type="section-australian-marble-score"]');

    buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.marbleScorePanel !== scoreIndex;
    });

    if (marker) marker.style.left = `${activeButton.dataset.scorePosition}%`;
    if (section) this.queueProductPanel(section, scoreIndex);
  }

  // INTERACTION: Product panels are already rendered; score changes only reveal the matching panel.
  queueProductPanel(section, scoreIndex) {
    const host = section.querySelector('[data-marble-products-host]');
    if (!host) return;

    host.querySelectorAll('[data-marble-products-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.marbleProductsPanel !== scoreIndex;
    });
  }

  handleClick = (event) => {
    const button = event.target.closest('[data-marble-score-button]');
    if (button) this.setActive(button);
  };

  handleKeydown = (event) => {
    const buttons = [...this.querySelectorAll('[data-marble-score-button]')];
    const activeButton = event.target.closest('[data-marble-score-button]');
    const index = buttons.indexOf(activeButton);
    if (index === -1) return;

    const lastIndex = buttons.length - 1;
    let nextIndex = index;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = Math.min(index + 1, lastIndex);
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = Math.max(index - 1, 0);
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = lastIndex;
    if (nextIndex === index) return;

    event.preventDefault();
    buttons[nextIndex].focus();
    this.setActive(buttons[nextIndex]);
  };
}

if (!customElements.get('marble-score-explorer')) {
  customElements.define('marble-score-explorer', MarbleScoreExplorer);
}
